var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-title",class:{
  'step-title--smaller': _vm.smaller,
  'step-title--little': _vm.little
}},[_vm._t("default"),_vm._v(" "),(_vm.step)?_c('span',{style:(_vm.stepStyle)},[_c('span',[_vm._v(_vm._s(_vm.$t('checkout.step')))]),_vm._v(" "+_vm._s(_vm.step)+":\n  ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }